/**
 * `set-contract-cloudeq-entity` — FR-27, NFR-06, NFR-07, CR-01. R-91-1 /
 * D-91-4 (Gerry, 15 Sep 2026) · CLM-91.
 *
 * The admin override on which cloudEQ legal entity signed a contract. The
 * store-conversion scan (D-91-1) sets `contract.cloudeq_entity_key` with
 * `source = 'text_scan'`; an admin may place a contract the scan could not, or
 * move one it placed wrongly. One scoped UPDATE (`root_contract_key` predicate,
 * rule 10 — unlike `set-party-region`, `contract` carries the anchor),
 * `source = 'admin'`, `scan_note = NULL`; `tg_contract_audit` writes the one
 * audit row (rule 7). **Later scans never overwrite an admin value**; `entity_key:
 * null` clears both columns and re-arms the scan.
 *
 * The override lives on the *contract*: the fact is per signed document, not
 * per client — the same client can sign a SOW with CEQ-IN and an MSA with
 * CEQ-UK. Gate `contract:set_cloudeq_entity` — admin only (the `party:set_region`
 * twin).
 */
import { z } from 'zod';
import { CloudeqEntityKeySchema, CloudeqEntitySourceSchema } from '../domain/cloudeq-entity.js';
import { ContractKeySchema } from '../primitives.js';
import { AuditReceiptSchema } from '../provenance.js';
export const SetContractCloudeqEntityRequestSchema = z
    .object({
    contract_key: ContractKeySchema,
    /** A registry key, or null = Unassigned (clears `cloudeq_entity_source` and the scan note; re-arms the scan). */
    entity_key: CloudeqEntityKeySchema.nullable(),
    /** Optional operator note — carried on the handler's `cloudeq_entity.set` log line, not stored on the contract. */
    note: z.string().min(1).max(500).optional(),
})
    .strict();
export const SetContractCloudeqEntityResponseSchema = z
    .object({
    contract_key: ContractKeySchema,
    cloudeq_entity_key: CloudeqEntityKeySchema.nullable(),
    /** `admin` after a set; null after a clear. */
    cloudeq_entity_source: CloudeqEntitySourceSchema.nullable(),
    /** The `tg_contract_audit` row of the UPDATE — the NFR-07 receipt. */
    audit: AuditReceiptSchema,
})
    .strict();
//# sourceMappingURL=set-contract-cloudeq-entity.js.map